<template>
    <modal :close="closeModal" printButton downloadButton :title="title" :printStyle="printStyle">
        <h3 slot="modalHeader"><i class="uk-icon-clock-o"></i> Записи в {{organ}}</h3>
        <div ref="htmlContent" class="records-content" slot="modalBody">
            <template>
                <h4 class="title">Регистрационные действия {{ companyName }}</h4>
                <ul class="records-list">
                    <item v-for="(r, i) in records" :key="i" :record="r" />
                </ul>
            </template>
        </div>
    </modal>
</template>

<script>
import modal from '@/components/ui/modal.vue'
import egrulRecordsItem from '@/components/card/egrulRecords/egrulRecordsItem.vue'

export default {
    components: {
        modal,
        item: egrulRecordsItem
    },
    props: {
        records: Array,
        title: String,
        companyName: String,
        organ: String
    },
    data: () => ({
        isShouldRendering: false,
        printStyle: `
            .print-main-title { 
                    border-bottom: 1px solid #4b6365;
                    color: #4b6365;
                    font-size: 25px;
                    margin-top: 0px;
                    margin-bottom: 0px;
                    text-align: center;
                    margin-bottom: 15px;
                    margin-top: 20px; 
            }
            .records-list { background: #eeeeef; padding: 20px;}
            .records-list ul { list-style-type: disc; }
            .record { border-bottom: 1px solid #9a9a9d; padding: 15px 0 }
        `
    }),
    methods: {
        closeModal() {
            this.$emit('close-modal')
        }
    },
    mounted() {
        setTimeout(() => {
            this.$emit('throw-html', this.$refs.htmlContent?.outerHTML)
        }, 250)
    }
}
</script>

<style lang="sass" scoped>
.records-content
    padding: 20px
.title
    font-size: 22px      
</style>